import React, { useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AccountContext } from '../Accounts';
import { DataTypeContext } from '../DataTypes';
import BSButton from '../form/BSButton';

const ThankYou = () => {
    const { t } = useTranslation();
    const { clientId, username } = useContext(AccountContext);
    const { dataTypes, isDeliveryEnabled } = useContext(DataTypeContext);
    const hasAppointment = dataTypes.agencies.length > 0 && dataTypes?.appointmentOptions?.enableAppointmentBooking;

    return (
        <Col md={6} sm={12} className="mx-auto">
            <br />
            <div className="card shadow-sm rounded p-4">
                    <h3 className="text-center display-4">✓</h3>
                    <h4 className="text-center">{t('account.confirmation.heading')}</h4>
                    <small dangerouslySetInnerHTML={{
                        __html: dataTypes.thankYouMessage
                            ? dataTypes.thankYouMessage
                            : '',
                        }}>
                    </small>
                    <br />

                    <div className="card p-3 bg-info mb-2">
                        <p className='mb-2'>{t('account.confirmation.yourLogin')}</p>
                        <h4 className='font-weight-bold mb-2'>{username}</h4>
                        <p className='mb-2'>{t('account.confirmation.yourClientId')}</p>
                        <h4 className='font-weight-bold mb-2'>{clientId}</h4>
                        <small>{t('account.confirmation.message')}</small>
                    </div>

                    <hr />

                    {hasAppointment && isDeliveryEnabled ? (
                        <Row className="justify-content-center">
                            <Col sm={5} md={6} lg={5} className="mb-3">
                                <BSButton as={Link} to="/book-delivery" variant="primary" className="d-block">
                                    {t('dashboard.bookDelivery')}
                                </BSButton>
                            </Col>
                            {<Col sm={5} md={6} lg={5} className="mb-3">
                                <BSButton as={Link} to="/book-appointment" variant="primary" className="d-block">
                                    {t('dashboard.bookPickup')}
                                </BSButton>
                            </Col>}
                        </Row>
                    ) : hasAppointment && (
                        <p className="text-center">
                            <BSButton as={Link} to="/book-appointment" variant="primary" className="d-block">
                                {t('dashboard.bookServices')}
                            </BSButton>
                        </p>
                    )}
            </div>

            <p className="text-center mt-3 mb-0">
                <Link to="/dashboard">{t('dashboard.return')}</Link>
            </p>
        </Col>
    );
};

export default ThankYou;
